// issue #4: 测试发版流程,验证test环境自动发布是否正确带上最新commit(无功能影响)
import './style.scss'
import 'swiper/css'
import 'swiper/css/pagination'
import 'vue3-photo-preview/dist/index.css'
import "vue-scroll-picker/lib/style.css"
import 'vant/lib/index.css'
import App from './App.vue'
import { createApp } from 'vue'
import { router } from './router'
import { createPinia } from 'pinia'
import fastclick from 'fastclick'
import vue3PhotoPreview from 'vue3-photo-preview'
import { useInstance } from './root'
import useTDesign from './packages/useTDesign'
import { registerAMapComponents } from './utils/amap-loader'
import useVant from './packages/useVant'
import useVueScrollPicker from './packages/useVueScrollPicker'
import useGeetest from './packages/useGeetest'
import SvgIcon from '@/components/svg-icon/index.vue'
import { useCustomDirectives } from './directives'
import { useResponsiveFontSize } from './hooks/useResponsiveFontSize'
import { useI18n } from './i18n'
import useVueLazyload from './packages/useVueLazyload'
import { useVueVirtualScroller } from './packages/useVueVirtualScroller'
const { init: initFontSize } = useResponsiveFontSize()
const pinia = createPinia()
const globalVideoManager = useGlobalVideoManager()
const app = createApp(App)
initFontSize()
// fastclick.FastClick.attach(document.body)
useInstance(app)
useTDesign(app)
useVant(app)
useVueScrollPicker(app)
useGeetest(app)
useI18n(app)
// 只注册组件（必须在启动时，否则 el-amap-* 解析不到）；SDK 脚本仍由
// ensureAMapLoaded() 按需拉。原因见 utils/amap-loader.ts 顶部。
registerAMapComponents(app)
app.component('SvgIcon', SvgIcon)
app.use(router)

app.use(pinia)
const gStore = useGlobalStore()
gStore.setPlatformInfo(getPlatformInfo())

app.use(vue3PhotoPreview)
app.use(useCustomDirectives)
app.use(useVueLazyload)
app.use(useVueVirtualScroller)
app.provide('globalVideoManager', globalVideoManager)
app.mount('#app')